import { userLoginForm } from "./UserLoginForm";
import { registerForm } from "./RegisterForm";

export default class User {
  constructor(user) {
    const {
      displayName,
      email,
      phoneNumber,
      photoURL,
      uid,
      firstName,
      lastName,
      fullName
    } = user;
    this.displayName = displayName;
    this.email = email;
    this.phoneNumber = phoneNumber;
    this.photoURL = photoURL;
    this.uid = uid;
    this.firstName = firstName;
    this.lastName = lastName;
    this.fullName = fullName || displayName;
  }
  setToken(token) {
    this.token = token.accessToken || null;
  }
  setProvider(provider = null) {
    this.provider = [provider];
  }
  getUser() {
    return this;
  }
  static getLoginForm() {
    return userLoginForm;
  }
  static getRegisterForm() {
    return registerForm;
  }
}
